import { render, staticRenderFns } from "./AudioUpload.vue?vue&type=template&id=63db62a2&"
import script from "./AudioUpload.vue?vue&type=script&lang=js&"
export * from "./AudioUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports